module.exports = __webpack_public_path__ + "img/anavil.9726e3f9.jpeg";